import React, { useCallback, useEffect, useRef, useState } from 'react';

/**
 * A row (tabs, chips…) that scrolls horizontally when it does not fit — never clipped silently.
 * A soft fade on the side(s) where more content waits is the visual hint; the scrollbar is hidden.
 */
export const ScrollableRow = ({ children, className = '', testId }) => {
  const ref = useRef(null);
  const [edges, setEdges] = useState({ left: false, right: false });

  const update = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    const left = el.scrollLeft > 2;
    const right = el.scrollLeft + el.clientWidth < el.scrollWidth - 2;
    setEdges((e) => (e.left === left && e.right === right ? e : { left, right }));
  }, []);

  useEffect(() => {
    update();
    const el = ref.current;
    if (!el) return undefined;
    let ro;
    if (typeof ResizeObserver !== 'undefined') { ro = new ResizeObserver(update); ro.observe(el); if (el.firstElementChild) ro.observe(el.firstElementChild); }
    window.addEventListener('resize', update);
    return () => { if (ro) ro.disconnect(); window.removeEventListener('resize', update); };
  }, [update]);

  const L = '2rem';
  const mask = edges.left || edges.right
    ? `linear-gradient(to right, ${edges.left ? 'transparent 0' : 'black 0'}, black ${edges.left ? L : '0'}, black calc(100% - ${edges.right ? L : '0px'}), ${edges.right ? 'transparent 100%' : 'black 100%'})`
    : undefined;

  return (
    <div
      ref={ref}
      onScroll={update}
      className={`overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden ${className}`}
      style={mask ? { WebkitMaskImage: mask, maskImage: mask } : undefined}
      data-testid={testId}
      data-scroll-more-right={edges.right ? 'true' : 'false'}
      data-scroll-more-left={edges.left ? 'true' : 'false'}
    >
      {children}
    </div>
  );
};

export default ScrollableRow;
